/**
 * 날짜 및 시간 포맷팅 유틸리티
 * Kpathport 전역에서 사용하는 날짜/시간 포맷팅 함수
 */

/**
 * 날짜 포맷팅 (예: "Fri ∙ 5 Dec 2025")
 * @param {string|Date} dateValue - 날짜 값 (YYYY-MM-DD 형식 문자열 또는 Date 객체)
 * @returns {string} 포맷팅된 날짜 문자열
 */
export const formatDate = (dateValue) => {
  if (!dateValue) return '';
  
  let date;
  if (typeof dateValue === 'string') {
    // YYYY-MM-DD 형식인 경우
    date = new Date(dateValue + 'T00:00:00');
  } else if (dateValue instanceof Date) {
    date = dateValue;
  } else {
    return '';
  }
  
  if (isNaN(date.getTime())) return '';
  
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const day = days[date.getDay()];
  const month = months[date.getMonth()];
  const dayNum = date.getDate();
  const year = date.getFullYear();
  
  return `${day} ∙ ${dayNum} ${month} ${year}`;
};

/**
 * 단일 시간 포맷팅 (예: "6:00 PM")
 * @param {string} timeString - 시간 문자열 (HH:mm:ss 또는 HH:mm 형식)
 * @returns {string} 포맷팅된 시간 문자열
 */
export const formatSingleTime = (timeString) => {
  if (!timeString) return '';
  
  const timeStr = typeof timeString === 'string' ? timeString : timeString.toString();
  const timeParts = timeStr.split(':');
  const hours = parseInt(timeParts[0], 10);
  
  if (isNaN(hours)) return '';
  
  const minutes = timeParts[1] || '00';
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHour = hours % 12 || 12;
  
  return `${displayHour}:${minutes} ${ampm}`;
};

/**
 * 시간 범위 포맷팅 (예: "6:00 PM - 8:00 PM")
 * @param {string} startTime - 시작 시간
 * @param {string} endTime - 종료 시간
 * @returns {string} 포맷팅된 시간 범위 문자열
 */
export const formatTime = (startTime, endTime) => {
  const start = formatSingleTime(startTime);
  const end = formatSingleTime(endTime);
  
  if (start && end) {
    return `${start} - ${end}`;
  }
  return start || end || '';
};

/**
 * 날짜와 시간을 함께 포맷팅
 * @param {string|Date} dateValue - 날짜 값
 * @param {string} startTime - 시작 시간
 * @param {string} endTime - 종료 시간
 * @returns {object} { date: string, time: string }
 */
export const formatDateTime = (dateValue, startTime, endTime) => {
  return {
    date: formatDate(dateValue),
    time: formatTime(startTime, endTime),
  };
};

